import { useWindowWidth } from "@react-hook/window-size";
import { styled } from "@sourceful/shared-components";
import YouTube from "react-youtube";

interface YouTubeVideoProps {
  youtubeId: string;
  height: number;
  width: number;
  autoplay?: boolean;
  controls?: boolean;
  showPlayer?: boolean;
}

const Container = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "start",
  width: "100%",
});

function boolToInt(bool: boolean) {
  return bool ? 1 : 0;
}

export function YouTubeVideo({
  width,
  youtubeId,
  autoplay = false,
  controls = true,
  showPlayer = true,
}: YouTubeVideoProps) {
  const windowWidth = useWindowWidth();
  const size = windowWidth <= 768 ? windowWidth - 30 : width;
  const options = {
    height: String(size),
    width: String(size),
    playerVars: {
      autoplay: boolToInt(autoplay),
      controls: boolToInt(controls),
      mute: 1,
      // post 25 Sept., 2018 we cannot completely disable the 'suggestions' YT shows when the video is paused
      // setting `rel` to 0 restricts suggestions to videos in our YT channel
      rel: 0,
    },
  };

  return <Container>{showPlayer && <YouTube videoId={youtubeId} opts={options} />}</Container>;
}
